import CredomaticSection from './CredomaticSection';
export default CredomaticSection;
